import {createSelector} from '../util';

export const getGuideById = createSelector(
  [
    (state, guideId) =>
      state.guide.get('guides').find((c) => c.get('id') === guideId),
  ],
  (guide) => (guide ? guide.toJS() : null)
);
